<template>
  <div v-if="!contentLoading" class="osh-balance-information-wrapper">
    <osh-balance-information-new v-if="monthReview"></osh-balance-information-new>
    <osh-balance-information-old v-else></osh-balance-information-old>
  </div>
</template>
<script>

import { mapGetters, mapActions, mapState } from 'vuex';
import OshBalanceInformationNew from './OshBalanceInformationNew';
import OshBalanceInformationOld from './OshBalanceInformationOld';
import casfhlowHistory from '../../../../../store/utilities/cashflow-history';
import { chooseFlow } from '../../navigation-pages/month-review/parse-transactions';

export default {
  components: {
    OshBalanceInformationNew,
    OshBalanceInformationOld,
  },
  name: 'OshBalanceInformation',
  data() {
    return {
      monthReview: false,
    };
  },

  async created() {
    this.startContentLoading(this.$options.name);
    await this.initBudgets({ budgetDate: this.budgetDate });
    this.monthReview = await chooseFlow(this.cashflowUITree);
    this.doneContentLoading(this.$options.name);
  },
  computed: {
    ...mapGetters('contentLoader', ['contentLoading']),
    ...mapState('cashflowView', ['cashflowUITree']),
    budgetDate() {
      return casfhlowHistory.getPrevBudgetDate(casfhlowHistory.getCurrentBudgetDate());
    },
  },
  methods: {
    ...mapActions('contentLoader', ['startContentLoading', 'doneContentLoading']),
    ...mapActions('cashflowView', ['initBudgets']),
  },
};
</script>

<style lang="scss">
@import '../../../../../../node_modules/base-ui/src/scss/riseup-colors';

.osh-balance-information-wrapper {
  height: 100%;
}

</style>
